import { render } from "./AgencyCard.vue?vue&type=template&id=1a22be2c&scoped=true&ts=true"
import script from "./AgencyCard.vue?vue&type=script&lang=ts"
export * from "./AgencyCard.vue?vue&type=script&lang=ts"

import "./AgencyCard.vue?vue&type=style&index=0&id=1a22be2c&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a22be2c"]])

export default __exports__